import {toAbsoluteUrl} from '../../../../../../_metronic/helpers/AssetHelpers'

type RenterHomeHeroProps = {
  applicantName: string
  submittedCount: number
  viewedCount: number
  isPrimaryApplicant?: boolean
  onSubmit?: () => void
  onFoundPlace?: () => void
}

export const RenterHomeHero: React.FC<RenterHomeHeroProps> = ({
  applicantName,
  submittedCount,
  viewedCount,
  isPrimaryApplicant,
  onSubmit,
  onFoundPlace,
}) => (
  <header className='renter-home-hero'>
    <div className='top renter-home-hero-inner'>
      <div className='head'>
        <button type='button' aria-label='Tap for Rental Help' className='helper'>
          <div
            className='logo'
            style={{
              maskImage: `url("${toAbsoluteUrl('/media/logos/doora-logo-white.png')}")`,
              WebkitMaskImage: `url("${toAbsoluteUrl('/media/logos/doora-logo-white.png')}")`,
            }}
          ></div>
          <span>Tap for Rental Help</span>
        </button>
        {isPrimaryApplicant ? (
          <button className='found-place' onClick={onFoundPlace}>
            <svg
              width='12'
              height='12'
              viewBox='0 0 20 20'
              fill='#F0A9D8'
              stroke='#F0A9D8'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <path d='M10 2.5l2.4 4.9 5.4.8-3.9 3.8.9 5.4L10 14.9l-4.8 2.5.9-5.4L2.2 8.2l5.4-.8L10 2.5z'></path>
            </svg>
            Found a place
          </button>
        ) : null}
      </div>
      <h1 className='welcome'>Welcome back{applicantName ? `, ${applicantName}` : ''}</h1>
      <div className='active-card'>
        <span></span>
        Card active · {submittedCount} submissions
      </div>
      <div className='renter-stats'>
          <div className='card'>
            <div className='value'>{submittedCount}</div>
            <div className='label'>Submitted</div>
          </div>
          <div className='card'>
            <div className='value'>{viewedCount}</div>
            <div className='label'>Viewed</div>
          </div>
      </div>
      {onSubmit && (
        <button className='btn-grad submit-property' onClick={onSubmit}>
          <svg
            width='16'
            height='16'
            viewBox='0 0 20 20'
            fill='none'
            stroke='#fff'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path d='M10 4v12M4 10h12'></path>
          </svg>{' '}
          Submit to property
        </button>
      )}
    </div>
  </header>
)
